export default "__VITE_ASSET__BrYSMCmL__"